<template>
  <div class="body">
    <div class="title">
      <span>{{ $t(`routeName.importOrder`) }}</span>
      <el-button type="text" @click="lastStep(2)" v-show="activeStep == 3">{{
        " <返回" }}</el-button>
    </div>
    <div class="tips" v-show="!orderTicketListLaunch">
      <span>当前授信额度：<span class="quota">{{ quota }}</span>元，已提交待审核订单金额：<span class="orderAmount">{{
        orderAmount
          }}</span>元。
        <span v-show="insufficientBalance">订单可能无法审核（现金支付不受影响）。为保障订单顺利通过审核，请尽快充值！</span></span>
    </div>
    <div class="step" v-show="!orderTicketListLaunch">
      <el-steps :active="activeStep" simple finish-status="success">
        <el-step>
          <template slot="title">
            <div class="stepItem">
              <span class="text1">第一步</span>
              <span class="text2">选择优惠票类</span>
            </div>
          </template>
        </el-step>
        <el-step>
          <template slot="title">
            <div class="stepItem">
              <span class="text1">第二步</span>
              <span class="text2">导入游客资料，生成订单</span>
            </div>
          </template>
        </el-step>
        <el-step>
          <template slot="title">
            <div class="stepItem">
              <span class="text1">第三步</span>
              <span class="text2">提交订单信息</span>
            </div>
          </template>
        </el-step>
      </el-steps>
    </div>
    <div class="step1" v-if="activeStep == 1">
      <div class="selectTicketType">
        <div class="ticketType">
          <span>优先优惠票类</span>
          <el-select v-model="ticketType" placeholder="请选择票类">
            <el-option v-for="item in options_ticketType" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="text">
          <span>文件格式为xlsx，游客条目最多支持200条。</span>
          <span>请下载文档模板，按规范填写。</span>
        </div>
        <div class="download">
          <el-button type="text" @click="downloadFile('导入订单模板.xlsx')">点击下载订单模板</el-button>
        </div>
      </div>
      <div class="next">
        <el-button type="primary" @click="nextStep(2)">下一步</el-button>
      </div>
    </div>
    <div class="step2" v-if="activeStep == 2">
      <div class="upload">
        <div class="uploadItem">
          <span>上传游客资料</span>
          <el-upload v-if="checkTouristList" class="uploadTouristInformation" action multiple :limit="1" accept=".xlsx"
            :file-list="fileList" :on-change="handleChange" :on-remove="handleRemove" :on-preview="handlePreview"
            :auto-upload="false">
            <el-button>点击上传</el-button>
          </el-upload>
          <div class="uploadSuccess" v-else @click="handlePreview(1)">
            <span>已导入{{ tableDataLength }}条游客资料，点击下一步生成订单</span>
          </div>
        </div>
        <div class="text">
          <span>文件格式为xlsx，游客条目最多支持200条。</span>
          <span>请下载文档模板，按规范填写。</span>
        </div>
        <div class="download">
          <el-button type="text" @click="downloadFile('导入订单模板.xlsx')">点击下载订单模板</el-button>
        </div>
      </div>
      <div class="nextOrBack">
        <el-button v-if="checkTouristList" @click="lastStep(1)">上一步</el-button>
        <el-button v-else @click="cancelCreate()">取消</el-button>
        <el-button type="primary" @click="createOrder(3)" :disabled="checkTouristList">下一步</el-button>
      </div>
    </div>
    <div class="step3" v-if="activeStep == 3">
      <div class="orderInformation" v-show="!orderTicketListLaunch">
        <el-row :gutter="20">
          <el-col :span="6">
            <span>创建日期：</span>
          </el-col>
          <el-col :span="7">
            <span>游玩日期：{{
              orderDetailsList.orderInformation.startTime +
              "—" +
              orderDetailsList.orderInformation.endTime
            }}</span>
          </el-col>
          <el-col :span="6">
            <span>旅行社名：{{ travelAgencyName }}</span>
          </el-col>
          <el-col :span="5">
            <span>团队区域：{{ orderDetailsList.orderInformation.teamArea }}</span>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="6">
            <span>导游姓名：{{ orderDetailsList.orderInformation.name }}</span>
          </el-col>
          <el-col :span="7">
            <span>导游手机：{{
              orderDetailsList.orderInformation.phoneNumber
            }}</span>
          </el-col>
          <el-col :span="6">
            <span>身份证号：{{ orderDetailsList.orderInformation.IDNumber }}</span>
          </el-col>
          <el-col :span="5">
            <span>团类型：{{ orderDetailsList.orderInformation.teamType }}</span>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="6">
            <span class="ellipsis" :title="orderDetailsList.orderInformation.specialPopulation">特殊人群：{{
              orderDetailsList.orderInformation.specialPopulation
            }}</span>
          </el-col>
          <el-col :span="7">
            <span>支付方式：
              <el-dropdown @command="handleCommand">
                <span class="el-dropdown-link">
                  {{
                    orderDetailsList.orderInformation.payWay == 99
                      ? "挂账"
                      : "现金"
                  }}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="99">挂账</el-dropdown-item>
                  <el-dropdown-item command="0">现金</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </span>
          </el-col>
          <el-col :span="11">
            <span class="ellipsis" :title="orderDetailsList.orderInformation.remarks">备注：{{
              orderDetailsList.orderInformation.remarks }}</span>
          </el-col>
        </el-row>
      </div>
      <div class="orderStatistics" v-show="!orderTicketListLaunch">
        <div class="orderNumber">
          <span class="orderNumberTitle">订单编号</span>
          <div class="line"></div>
          <span class="orderNumberText">{{ orderStatistics.orderNumber }}</span>
        </div>
        <div class="orderAmount">
          <span class="orderAmountTitle">订单金额</span>
          <div class="line"></div>
          <span class="orderAmountText">{{ orderStatistics.orderAmount }}</span>
        </div>
        <div class="orderPeopleNum">
          <span class="orderPeopleNumTitle">订单人数</span>
          <div class="line"></div>
          <span class="orderPeopleNumText">{{
            orderStatistics.orderPeopleNum
          }}</span>
        </div>

        <div class="orderTicketPeopleList" v-for="item in orderStatistics.orderTicketList" :key="item.ticketName"
          :style="`width:${72 / orderStatistics.orderTicketList.length}%`">
          <span class="orderTicketPeopleListTitle">{{ item.ticketName }}</span>
          <div class="line"></div>
          <span class="orderTicketPeopleListText">{{ item.num }}</span>
        </div>
      </div>
      <div class="orderTicketList">
        <div class="selectVisitor">
          <el-tabs v-model="activeName" class="tables" @tab-click="handleClick">
            <el-tab-pane name="1">
              <span slot="label">&nbsp;&nbsp;&nbsp;&nbsp;全部门票&nbsp;&nbsp;&nbsp;&nbsp;</span>
              <div>
                <div class="ticketList">
                  <el-table :data="ticketListTable" style="width: 100%" :header-cell-style="thStyleFun"
                    :cell-style="cellStyleFun">
                    <el-table-column label="票类名称" center>
                      <template slot-scope="scope">
                        <span>{{ scope.row.ticketName }}</span>
                        <span v-show="scope.row.isConcession" class="favourable">惠</span>
                        <span v-show="!scope.row.isConcession" class="ordinary">普</span>
                      </template>
                    </el-table-column>
                    <el-table-column label="金额" center width="70">
                      <template slot-scope="scope">
                        <span>{{ scope.row.price }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column label="姓名" center width="100">
                      <template slot-scope="scope">
                        <span>{{ scope.row.name }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column label="证件号" center width="180">
                      <template slot-scope="scope">
                        <span>{{ scope.row.certificateNumber }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column label="证件类型" center width="100">
                      <template slot-scope="scope">
                        <span>{{ scope.row.certificateTypeText }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column label="手机号" center width="120">
                      <template slot-scope="scope">
                        <span>{{ scope.row.phoneNumber }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column label="佐证材料" center width="100">
                      <template slot-scope="scope">
                        <span>{{ scope.row.supportingMaterialsText }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column label="性别" center width="50">
                      <template slot-scope="scope">
                        <span>{{ scope.row.sex }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column label="年龄" center width="60">
                      <template slot-scope="scope">
                        <span>{{ scope.row.age }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column label="区域" center width="70">
                      <template slot-scope="scope">
                        <span>{{ scope.row.area }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column label="备注" center>
                      <template slot-scope="scope">
                        <span :title="scope.row.remarks" class="ellipsis">{{
                          scope.row.remarks
                        }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column label="匹配依据" center width="120">
                      <template slot-scope="scope">
                        <span v-for="item in scope.row.matchingDetails" :key="item">{{ item }}<br /></span>
                      </template>
                    </el-table-column>
                    <el-table-column :label="$t('ticketorder.scope')" fixed="right" width="150">
                      <template slot-scope="scope">
                        <el-button size="mini" icon="el-icon-edit" circle type="success"
                          @click="editTicket_tab1(scope.row)"></el-button>
                        <el-popconfirm title="确认删除此票吗?" style="margin-left: 10px"
                          @confirm="deleteTicket_tab1(scope.row)">
                          <el-button slot="reference" size="mini" type="danger" icon="el-icon-delete"
                            circle></el-button>
                        </el-popconfirm>
                      </template>
                    </el-table-column>
                  </el-table>

                  <div style="
                      display: flex;
                      justify-content: space-between;
                      align-items: center;
                      margin-top: 15px;
                    ">
                    <el-pagination @current-change="handleCurrentChange_ticketList_tab1"
                      :current-page="page_ticketList.pageNumber" :page-size="page_ticketList.pageItems"
                      layout="total, prev, pager, next, jumper" :total="ticketListTableDataLength" background
                      style="margin-left: 10px" />
                    <div>
                      <el-button type="primary" size="medium" @click="saveOrder">保存订单</el-button>
                      <el-button type="success" size="medium" @click="addTourists_tab1">添加游客</el-button>
                      <el-button type="primary" size="medium" @click="confirmOrder"
                        style="margin-right: 20px">提交审核</el-button>
                    </div>
                  </div>
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane name="2">
              <span slot="label">&nbsp;&nbsp;&nbsp;&nbsp;优惠门票&nbsp;&nbsp;&nbsp;&nbsp;</span>
              <div>
                <div class="ticketList">
                  <el-table :data="ticketListTable" style="width: 100%" :header-cell-style="thStyleFun"
                    :cell-style="cellStyleFun">
                    <el-table-column label="票类名称" center>
                      <template slot-scope="scope">
                        <span>{{ scope.row.ticketName }}</span>
                        <span class="favourable">惠</span>
                      </template>
                    </el-table-column>
                    <el-table-column label="金额" center width="70">
                      <template slot-scope="scope">
                        <span>{{ scope.row.price }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column label="姓名" center width="100">
                      <template slot-scope="scope">
                        <span>{{ scope.row.name }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column label="证件号" center width="180">
                      <template slot-scope="scope">
                        <span>{{ scope.row.certificateNumber }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column label="证件类型" center width="100">
                      <template slot-scope="scope">
                        <span>{{ scope.row.certificateTypeText }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column label="手机号" center width="120">
                      <template slot-scope="scope">
                        <span>{{ scope.row.phoneNumber }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column label="佐证材料" center width="100">
                      <template slot-scope="scope">
                        <span>{{ scope.row.supportingMaterialsText }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column label="性别" center width="50">
                      <template slot-scope="scope">
                        <span>{{ scope.row.sex }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column label="年龄" center width="60">
                      <template slot-scope="scope">
                        <span>{{ scope.row.age }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column label="区域" center width="70">
                      <template slot-scope="scope">
                        <span>{{ scope.row.area }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column label="备注" center>
                      <template slot-scope="scope">
                        <span :title="scope.row.remarks" class="ellipsis">{{
                          scope.row.remarks
                        }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column label="匹配依据" center width="120">
                      <template slot-scope="scope">
                        <span v-for="item in scope.row.matchingDetails" :key="item">{{ item }}<br /></span>
                      </template>
                    </el-table-column>
                    <el-table-column :label="$t('ticketorder.scope')" fixed="right" width="150">
                      <template slot-scope="scope">
                        <el-button size="mini" icon="el-icon-edit" circle type="success"
                          @click="editTicket_tab2(scope.row)"></el-button>
                        <el-popconfirm title="确认删除此票吗?" style="margin-left: 10px"
                          @confirm="deleteTicket_tab2(scope.row)">
                          <el-button slot="reference" size="mini" type="danger" icon="el-icon-delete"
                            circle></el-button>
                        </el-popconfirm>
                      </template>
                    </el-table-column>
                  </el-table>

                  <div style="
                      display: flex;
                      justify-content: space-between;
                      align-items: center;
                      margin-top: 15px;
                    ">
                    <el-pagination @current-change="handleCurrentChange_ticketList_tab2"
                      :current-page="page_ticketList.pageNumber" :page-size="page_ticketList.pageItems"
                      layout="total, prev, pager, next, jumper" :total="ticketListTableDataLength" background
                      style="margin-left: 10px" />
                    <div>
                      <el-button type="primary" size="medium" @click="saveOrder">保存订单</el-button>
                      <el-button type="success" size="medium" @click="addTourists_tab2">添加游客</el-button>
                      <el-button type="primary" size="medium" @click="confirmOrder"
                        style="margin-right: 20px">提交审核</el-button>
                    </div>
                  </div>
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane name="3">
              <span slot="label">&nbsp;&nbsp;&nbsp;&nbsp;普通门票&nbsp;&nbsp;&nbsp;&nbsp;</span>
              <div>
                <div class="ticketList">
                  <el-table :data="ticketListTable" style="width: 100%" :header-cell-style="thStyleFun"
                    :cell-style="cellStyleFun">
                    <el-table-column label="票类名称" center>
                      <template slot-scope="scope">
                        <span>{{ scope.row.ticketName }}</span>
                        <span class="ordinary">普</span>
                      </template>
                    </el-table-column>
                    <el-table-column label="金额" center width="70">
                      <template slot-scope="scope">
                        <span>{{ scope.row.price }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column label="姓名" center width="100">
                      <template slot-scope="scope">
                        <span>{{ scope.row.name }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column label="证件号" center width="180">
                      <template slot-scope="scope">
                        <span>{{ scope.row.certificateNumber }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column label="证件类型" center width="100">
                      <template slot-scope="scope">
                        <span>{{ scope.row.certificateTypeText }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column label="手机号" center width="120">
                      <template slot-scope="scope">
                        <span>{{ scope.row.phoneNumber }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column label="佐证材料" center width="100">
                      <template slot-scope="scope">
                        <span>{{ scope.row.supportingMaterialsText }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column label="性别" center width="50">
                      <template slot-scope="scope">
                        <span>{{ scope.row.sex }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column label="年龄" center width="60">
                      <template slot-scope="scope">
                        <span>{{ scope.row.age }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column label="区域" center width="70">
                      <template slot-scope="scope">
                        <span>{{ scope.row.area }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column label="备注" center>
                      <template slot-scope="scope">
                        <span :title="scope.row.remarks" class="ellipsis">{{
                          scope.row.remarks
                        }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column label="匹配依据" center width="120">
                      <template slot-scope="scope">
                        <span v-for="item in scope.row.matchingDetails" :key="item">{{ item }}<br /></span>
                      </template>
                    </el-table-column>
                    <el-table-column :label="$t('ticketorder.scope')" fixed="right" width="150">
                      <template slot-scope="scope">
                        <el-button size="mini" icon="el-icon-edit" circle type="success"
                          @click="editTicket_tab3(scope.row)"></el-button>
                        <el-popconfirm title="确认删除此票吗?" style="margin-left: 10px"
                          @confirm="deleteTicket_tab3(scope.row)">
                          <el-button slot="reference" size="mini" type="danger" icon="el-icon-delete"
                            circle></el-button>
                        </el-popconfirm>
                      </template>
                    </el-table-column>
                  </el-table>

                  <div style="
                      display: flex;
                      justify-content: space-between;
                      align-items: center;
                      margin-top: 15px;
                    ">
                    <el-pagination @current-change="handleCurrentChange_ticketList_tab3"
                      :current-page="page_ticketList.pageNumber" :page-size="page_ticketList.pageItems"
                      layout="total, prev, pager, next, jumper" :total="ticketListTableDataLength" background
                      style="margin-left: 10px" />
                    <div>
                      <el-button type="primary" size="medium" @click="saveOrder">保存订单</el-button>
                      <el-button type="success" size="medium" @click="addTourists_tab3">添加游客</el-button>
                      <el-button type="primary" size="medium" @click="confirmOrder"
                        style="margin-right: 20px">提交审核</el-button>
                    </div>
                  </div>
                </div>
              </div>
            </el-tab-pane>
          </el-tabs>
          <div class="btn-area">
            <el-input size="medium" v-model="selectVisitor" style="width: 350px; margin-right: 10px"
              placeholder="列表查询：输入身份证/姓名/手机号" @change="selectVisitorFun()" clearable>
            </el-input>
            <el-button v-show="!orderTicketListLaunch" type="text" @click="orderTicketListLaunch = true">展开</el-button>
            <el-button v-show="orderTicketListLaunch" type="text" @click="orderTicketListLaunch = false">收起</el-button>
          </div>
        </div>
      </div>
    </div>

    <el-dialog class="preview" title="游客预览" :visible.sync="dialogTableVisible" width="70%" top="5vh">
      <el-table :data="touristList_paginate" :row-class-name="tableRowClassName" :header-cell-style="thStyleFun"
        :cell-style="cellStyleFun">
        <el-table-column property="name" label="游客姓名" width="200"></el-table-column>
        <el-table-column property="certificateNumber" label="游客证件号" width="200"></el-table-column>
        <el-table-column property="certificateTypeText" label="证件类型"></el-table-column>
        <el-table-column property="phoneNumber" label="游客手机号" width="120"></el-table-column>
        <el-table-column property="supportingMaterialsText" label="佐证材料"></el-table-column>
        <el-table-column property="sex" label="游客性别" width="90"></el-table-column>
        <el-table-column property="belongingArea" label="所属区域（省/市）" width="150"></el-table-column>
        <el-table-column property="height" label="身高(厘米)" width="100"></el-table-column>
        <el-table-column label="备注">
          <template slot-scope="scope">
            <span class="ellipsis" :title="scope.row.remarks">{{
              scope.row.remarks
            }}</span>
          </template>
        </el-table-column>
        <el-table-column label="结果">
          <template slot-scope="scope">
            <span v-for="item in scope.row.result" :key="item">{{ item }}<br /></span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="page.pageNumber" :page-sizes="[10, 20, 50, 100, 200]" :page-size="1"
        layout="total, sizes, prev, pager, next, jumper" :total="tableDataLength" background style="margin-top: 20px" />
      <div style="display: flex; justify-content: end; margin-top: 15px">
        <el-button type="primary" @click="confirm">确认</el-button>
        <el-button @click="cancel">取消</el-button>
      </div>
    </el-dialog>

    <el-drawer title="新增游客" :visible.sync="addTouristsDrawer" class="addFormDrawer">
      <div slot="title" class="custom-title">
        <i class="el-icon-finished"></i> <span>新增游客</span>
      </div>
      <div class="addTouristsForm">
        <el-form ref="addTouristsForm" :model="addTouristsForm" :rules="addTouristsRules" label-width="100px"
          label-position="right">
          <el-form-item label="证件号" prop="certificateNumber">
            <el-input v-model="addTouristsForm.certificateNumber" placeholder="请输入证件号" clearable></el-input>
          </el-form-item>
          <el-form-item label="证件类型" prop="certificateType">
            <el-select v-model="addTouristsForm.certificateType" placeholder="请选择证件类型" style="width: 100%">
              <el-option v-for="item in addTouristsForm.certificateTypeList" :key="item.value" :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="姓名" prop="name">
            <el-input v-model="addTouristsForm.name" placeholder="请输入游客姓名"></el-input>
          </el-form-item>
          <el-form-item label="手机号码" prop="phoneNumber">
            <el-input v-model="addTouristsForm.phoneNumber" placeholder="请输入手机号码"></el-input>
          </el-form-item>
          <el-form-item label="佐证材料" prop="supportingMaterials">
            <el-select v-model="addTouristsForm.supportingMaterials" placeholder="请选择" style="width: 100%">
              <el-option key="1" label="是" value="1"></el-option>
              <el-option key="0" label="否" value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="性别" prop="sex">
            <el-select v-model="addTouristsForm.sex" placeholder="请选择性别" style="width: 100%">
              <el-option key="0" label="男" value="0"></el-option>
              <el-option key="1" label="女" value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="区域" prop="area">
            <el-input v-model="addTouristsForm.area"></el-input>
          </el-form-item>
          <el-form-item label="身高" prop="height">
            <el-input type="number" v-model="addTouristsForm.height">
              <template slot="append">厘米</template>
            </el-input>
          </el-form-item>
          <el-form-item label="备注" prop="remarks">
            <el-input type="textarea" v-model="addTouristsForm.remarks"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="addDrawerFooter">
        <el-button class="submitAdd" type="primary" @click="submitAddTourists('addTouristsForm')">确认</el-button>
        <el-button class="cancelAdd" type="info" @click="cancelAddTouristsFormDrawer('addTouristsForm')">取 消</el-button>
      </div>
    </el-drawer>

    <el-drawer title="编辑游客" :visible.sync="editTouristsDrawer" class="editFormDrawer">
      <div slot="title" class="custom-title">
        <i class="el-icon-finished"></i> <span>编辑游客</span>
      </div>
      <div class="editTouristsForm">
        <el-form ref="editTouristsForm" :model="editTouristsForm" :rules="editTouristsRules" label-width="100px"
          label-position="right">
          <el-form-item label="证件号" prop="certificateNumber">
            <el-input v-model="editTouristsForm.certificateNumber" placeholder="请输入证件号" clearable></el-input>
          </el-form-item>
          <el-form-item label="证件类型" prop="certificateType">
            <el-select v-model="editTouristsForm.certificateType" placeholder="请选择证件类型" @change="editTicketTypeChange"
              style="width: 100%">
              <el-option v-for="item in editTouristsForm.certificateTypeList" :key="item.value" :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="票类名称" prop="ticketTypeId">
            <el-select v-model="editTouristsForm.ticketTypeId" placeholder="请选择票类" @change="editTicketTypeChange"
              style="width: 100%">
              <el-option v-for="item in options_ticketType_all" :key="item.value" :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="金额" prop="price">
            <el-input v-model="editTouristsForm.price" disabled></el-input>
          </el-form-item>
          <el-form-item label="优惠购票" prop="isConcession">
            <el-input v-model="editTouristsForm.isConcession" disabled></el-input>
          </el-form-item>
          <el-form-item label="姓名" prop="name">
            <el-input v-model="editTouristsForm.name" placeholder="请输入游客姓名"></el-input>
          </el-form-item>
          <el-form-item label="手机号码" prop="phoneNumber">
            <el-input v-model="editTouristsForm.phoneNumber" placeholder="请输入手机号码"></el-input>
          </el-form-item>
          <el-form-item label="佐证材料" prop="supportingMaterials">
            <el-select v-model="editTouristsForm.supportingMaterials" placeholder="请选择" style="width: 100%">
              <el-option key="1" label="是" value="1"></el-option>
              <el-option key="0" label="否" value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="性别" prop="sex">
            <el-select v-model="editTouristsForm.sex" placeholder="请选择性别" style="width: 100%"
              :disabled="editTouristsForm.certificateType == 0">
              <el-option key="0" label="男" value="0"></el-option>
              <el-option key="1" label="女" value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="年龄" prop="age">
            <el-input-number v-model="editTouristsForm.age" :min="0" controls-position="right"
              :disabled="editTouristsForm.certificateType == 0" style="width: 100%;"></el-input-number>
          </el-form-item>
          <el-form-item label="区域" prop="area">
            <el-input v-model="editTouristsForm.area" :disabled="editTouristsForm.certificateType == 0"></el-input>
          </el-form-item>
          <el-form-item label="身高" prop="height">
            <el-input type="number" v-model="editTouristsForm.height">
              <template slot="append">厘米</template>
            </el-input>
          </el-form-item>
          <el-form-item label="备注" prop="remarks">
            <el-input type="textarea" v-model="editTouristsForm.remarks"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="editDrawerFooter">
        <el-button class="submitEdit" type="primary" @click="submitEditTourists('editTouristsForm')">确认</el-button>
        <el-button class="cancelEdit" type="info" @click="cancelEditTouristsFormDrawer('editTouristsForm')">取
          消</el-button>
      </div>
    </el-drawer>
  </div>
</template>
<script>
export default {
  data() {
    return {
      travelAgencyName: "",
      travelAgencyID: "",
      userId: "",
      quota: "20000",
      orderAmount: "150000",
      insufficientBalance: true,
      activeStep: 1,
      ticketType: "",
      options_ticketType: [],
      options_ticketType_all: [],
      fileList: [],
      fileTemp: "",
      orderMsg: true,
      orderInformation: [],
      touristList: [],
      touristList_paginate: [],
      tableDataLength: 0,
      page: {
        pageNumber: 1,
        pageItems: 10
      },
      dialogTableVisible: false,
      checkTouristList: true,
      orderDetailsList: {
        orderInformation: {},
        ticketList: []
      },
      createTime: "",
      orderStatistics: {
        orderNumber: "无",
        orderAmount: 0,
        orderPeopleNum: 0,
        orderTicketList: []
      },
      selectVisitor: "",
      selectTabsIndex: "1",
      activeName: "1",
      orderTicketListLaunch: false,

      ticketListTable: [],
      page_ticketList: {
        pageNumber: 1,
        pageItems: 10
      },
      ticketListTableDataLength: 0,

      certificateTypeList: ["身份证", "港澳通行证", "护照"],
      addTouristsDrawer: false,
      addTouristsForm: {
        certificateType: 0,
        certificateTypeList: [
          {
            value: 0,
            label: "身份证"
          },
          {
            value: 1,
            label: "港澳通行证"
          },
          {
            value: 2,
            label: "护照"
          }
        ]
      },
      addTouristsRules: {
        certificateNumber: [
          { required: true, message: "证件号不能为空", trigger: "blur" }
        ],
        certificateType: [
          { required: true, message: "证件类型不能为空", trigger: "blur" }
        ],
        name: [
          { required: true, message: "游客姓名不能为空", trigger: "blur" }
        ],
        phoneNumber: [
          { required: true, message: "手机号码不能为空", trigger: "blur" },
          {
            pattern: /^1[3-9]\d{9}$/,
            message: "手机号码格式不正确",
            trigger: "blur"
          }
        ]
      },

      editTouristsDrawer: false,
      editTouristsForm: {
        index: "",
        tabsIndex: "",
        certificateNumber: "",
        certificateType: "",
        certificateTypeList: [
          {
            value: 0,
            label: "身份证"
          },
          {
            value: 1,
            label: "港澳通行证"
          },
          {
            value: 2,
            label: "护照"
          }
        ],
        ticketTypeId: "",
        price: "",
        isConcession: "",
        name: "",
        phoneNumber: "",
        supportingMaterials: "",
        supportingMaterialsText: "",
        sex: "",
        age: "",
        area: "",
        height: "",
        remarks: "",
        matchingDetails: ""
      },
      editTouristsRules: {
        certificateNumber: [
          { required: true, message: "证件号不能为空", trigger: "blur" }
        ],
        certificateType: [
          { required: true, message: "证件类型不能为空", trigger: "blur" }
        ],
        name: [
          { required: true, message: "游客姓名不能为空", trigger: "blur" }
        ],
        age: [
          { required: true, message: "年龄不能为空", trigger: "blur" }
        ],
        phoneNumber: [
          { required: true, message: "手机号码不能为空", trigger: "blur" },
          {
            pattern: /^1[3-9]\d{9}$/,
            message: "手机号码格式不正确",
            trigger: "blur"
          }
        ]
      }
    };
  },
  mounted() {
    let storage = window.sessionStorage;
    this.travelAgencyName = JSON.parse(
      storage.getItem("travelAgency")
    ).travelAgencyName;
    this.travelAgencyID = JSON.parse(storage.getItem("travelAgency")).id;
    this.userId = storage.getItem("userId");
    this.getTravelAgencyMenuQuota();
    // setInterval(() => {
    //     this.getTravelAgencyMenuQuota()
    //  }, 60000)
    this.getTicketTypeList();
    this.getAllTicketTypeList();
  },
  methods: {
    //! 获取当前旅行社的余额和未提交的订单总额
    getTravelAgencyMenuQuota() {
      this.$axios({
        url: "/api/travelAgency/unhandledOrderAmount",
        method: "post",
        data: {
          travelAgencyID: this.travelAgencyID
        }
      })
        .then(res => {
          console.log(res);
          if (res.data.res_code == "success") {
            this.quota = res.data.data.balance;
            this.orderAmount = res.data.data.unhandledOrderAmount;
            if (this.orderAmount > this.quota) {
              this.insufficientBalance = true;
            } else {
              this.insufficientBalance = false;
            }
          }
        })
        .catch(error => {
          this.$message({
            showClose: true,
            message: "获取旅行社余额错误！" + error,
            type: "error",
            duration: 10000
          });
        });
    },

    //! 获取当前旅行社下的所有有优惠的规则的票类
    getTicketTypeList() {
      let storage = window.sessionStorage;
      let travelAgencyID = JSON.parse(storage.getItem("travelAgency")).id;
      this.$axios({
        url: "/api/ticketType/travelAgencyTicket",
        method: "get",
        params: {
          travelAgencyID: travelAgencyID,
          invalid: 0,
          pageNumber: 1,
          pageItems: 9999
        }
      })
        .then(res => {
          console.log(res);
          if (res.data.res_code == "success") {
            this.options_ticketType = [];
            res.data.data[0].forEach(item => {
              if (item.isSettingTicketAuthorization) {
                let isConcession = false;
                if (item.ticketMatch.length > 0) {
                  if (item.ticketMatch[0].invalid == 0) {
                    isConcession = true;
                  }
                }
                this.options_ticketType.push({
                  value: item.id,
                  label: item.ticketTypeName,
                  price: item.ticketPrice,
                  isConcession: isConcession
                });
              }
            });
          } else {
            this.$message({
              showClose: true,
              message: "获取票类失败" + res.data.res_msg,
              type: "error",
              duration: 10000
            });
          }
        })
        .catch(error => {
          this.$message({
            showClose: true,
            message: "获取票类失败" + error,
            type: "error",
            duration: 10000
          });
        });
    },

    //! 获取当前旅行社下的所有的规则的票类
    getAllTicketTypeList() {
      let storage = window.sessionStorage;
      let travelAgencyID = JSON.parse(storage.getItem("travelAgency")).id;
      this.$axios({
        url: "/api/ticketType/travelAgencyTicket",
        method: "get",
        params: {
          travelAgencyID: travelAgencyID,
          pageNumber: 1,
          pageItems: 9999
        }
      })
        .then(res => {
          console.log(res);
          if (res.data.res_code == "success") {
            this.options_ticketType_all = [];
            res.data.data[0].forEach(item => {
              if (item.isSettingTicketAuthorization) {
                let isConcession = false;
                if (item.ticketMatch.length > 0) {
                  if (item.ticketMatch[0].invalid == 0) {
                    isConcession = true;
                  }
                }
                this.options_ticketType_all.push({
                  value: item.id,
                  label: item.ticketTypeName,
                  price: item.ticketPrice,
                  isConcession: isConcession
                });
              }
            });
          } else {
            this.$message({
              showClose: true,
              message: "获取票类失败" + res.data.res_msg,
              type: "error",
              duration: 10000
            });
          }
        })
        .catch(error => {
          this.$message({
            showClose: true,
            message: "获取票类失败" + error,
            type: "error",
            duration: 10000
          });
        });
    },

    //! 下载导入模板
    downloadFile(filename) {
      const fileUrl = "../../../../static/" + filename; // 文件的URL地址
      this.$download(fileUrl, filename);
    },

    //! 文件上传后校验文件类型
    handleChange(file, fileList) {
      console.log(file);
      this.fileTemp = file.raw;
      if ( this.fileTemp.type == "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
        this.fileTemp.type == "application/vnd.ms-excel"
      ) {
        this.generatePreview(this.fileTemp);
      } else {
        this.$message({
          type: "warning",
          message: "上传文件类型错误，请删除后重新上传！",
          duration: 10000
        });
      }
    },

    //! 读取上传文件内容形成Table
    generatePreview(obj) {
      var rABS = false; //是否将文件读取为二进制字符串
      var file = obj;
      var reader = new FileReader();
      let _this = this;
      FileReader.prototype.readAsBinaryString = function (file) {
        var binary = "";
        var wb; //读取完成的数据
        var outData;
        var reader = new FileReader();
        reader.onload = function (e) {
          var bytes = new Uint8Array(reader.result);
          var length = bytes.byteLength;
          for (var i = 0; i < length; i++) {
            binary += String.fromCharCode(bytes[i]);
          }
          var XLSX = require("xlsx");
          wb = XLSX.read(binary, {
            type: "binary",
            cellDates: true,
            UTC: true
          });
          var sheet = wb.Sheets[wb.SheetNames[0]];

          // 提取第一个表
          var range1 = { s: { r: 0, c: 0 }, e: { r: 1, c: 20 } }; // 范围从第1行到第2行，以第一行作为表头
          var table1 = XLSX.utils.sheet_to_json(sheet, { range: range1 });

          // 提取第二个表
          var range2 = { s: { r: 3, c: 0 }, e: { r: 204, c: 20 } }; // 范围从第4行到第205行，以第四行作为表头
          var table2 = XLSX.utils.sheet_to_json(sheet, { range: range2 });
          console.log("Table 2:", table2);

          _this.processTable1(table1);
          if (_this.orderMsg) {
            _this.processTable2(table2);
          }
        };

        reader.readAsArrayBuffer(file);
      };
      if (rABS) {
        reader.readAsArrayBuffer(file);
      } else {
        reader.readAsBinaryString(file);
      }
    },

    //! 处理文件第一个表
    processTable1(table1) {
      this.orderMsg = true;
      const processedTable1 = table1.map(row => {
        return {
          startTime: row["游玩时间"],
          endTime: row["游玩时间"],
          payWay: row["支付方式"],
          name: row["导游姓名"],
          phoneNumber: row["导游手机号"],
          IDNumber: row["导游身份证号"],
          specialPopulation: row["特殊人群"],
          teamArea: row["团队区域"],
          teamType: row["团类型"],
          remarks: row["备注"]
        };
      });
      if (processedTable1.length > 0) {
        this.orderInformation = processedTable1;
        console.log(this.orderInformation);
        for (let key in this.orderInformation[0]) {
          if (key === "startTime") {
            if (this.orderInformation[0][key] !== undefined) {
              if (this.orderInformation[0][key] instanceof Date) {
                this.orderInformation[0][key] = this.orderInformation[0][key].toString().trim();
                if (!isNaN(Date.parse(this.orderInformation[0][key]))) {
                  let time = new Date(this.orderInformation[0][key]);
                  time.setUTCDate(time.getUTCDate() + 1)
                  this.orderInformation[0][key] = `${time.getUTCFullYear()}-${String(time.getUTCMonth() + 1).padStart(2, "0")}-${String(time.getUTCDate()).padStart(2, "0")} 00:00:00`;
                } else {
                  this.$message({
                    showClose: true,
                    message: "游玩时间格式错误!",
                    type: "error",
                    duration: 10000
                  });
                  this.fileList = [];
                  this.orderMsg = false;
                  return;
                }
              } else {
                this.orderInformation[0][key] = this.orderInformation[0][key]
                  .toString()
                  .trim();
                if (!isNaN(Date.parse(this.orderInformation[0][key]))) {
                  let time = new Date(this.orderInformation[0][key]);
                  this.orderInformation[0][
                    key
                  ] = `${time.getUTCFullYear()}-${String(
                    time.getUTCMonth() + 1
                  ).padStart(2, "0")}-${String(time.getUTCDate()).padStart(
                    2,
                    "0"
                  )} 00:00:00`;
                } else {
                  this.$message({
                    showClose: true,
                    message: "游玩时间格式错误!",
                    type: "error",
                    duration: 10000
                  });
                  this.fileList = [];
                  this.orderMsg = false;
                  return;
                }
              }
            } else {
              this.$message({
                showClose: true,
                message: "游玩开始时间不能为空!",
                type: "error",
                duration: 10000
              });
              this.fileList = [];
              this.orderMsg = false;
              return;
            }
          }

          if (key === "endTime") {
            if (this.orderInformation[0][key] !== undefined) {
              if (this.orderInformation[0][key] instanceof Date) {
                this.orderInformation[0][key] = this.orderInformation[0][key]
                  .toString()
                  .trim();
                if (!isNaN(Date.parse(this.orderInformation[0][key]))) {
                  let time = new Date(this.orderInformation[0][key]);
                  time.setUTCDate(time.getUTCDate() + 1)
                  this.orderInformation[0][
                    key
                  ] = `${time.getUTCFullYear()}-${String(
                    time.getUTCMonth() + 1
                  ).padStart(2, "0")}-${String(time.getUTCDate()).padStart(
                    2,
                    "0"
                  )} 23:59:59`;
                } else {
                  this.$message({
                    showClose: true,
                    message: "游玩时间格式错误!",
                    type: "error",
                    duration: 10000
                  });
                  this.fileList = [];
                  this.orderMsg = false;
                  return;
                }
              } else {
                this.orderInformation[0][key] = this.orderInformation[0][key]
                  .toString()
                  .trim();
                if (!isNaN(Date.parse(this.orderInformation[0][key]))) {
                  let time = new Date(this.orderInformation[0][key]);
                  this.orderInformation[0][
                    key
                  ] = `${time.getUTCFullYear()}-${String(
                    time.getUTCMonth() + 1
                  ).padStart(2, "0")}-${String(time.getUTCDate()).padStart(
                    2,
                    "0"
                  )} 23:59:59`;
                } else {
                  this.$message({
                    showClose: true,
                    message: "游玩时间格式错误!",
                    type: "error",
                    duration: 10000
                  });
                  this.fileList = [];
                  this.orderMsg = false;
                  return;
                }
              }
            } else {
              this.$message({
                showClose: true,
                message: "游玩时间不能为空!",
                type: "error",
                duration: 10000
              });
              this.fileList = [];
              this.orderMsg = false;
              return;
            }
          }

          if (key === "payWay") {
            console.log(this.orderInformation[0][key]);

            if (this.orderInformation[0][key] !== undefined) {
              this.orderInformation[0][key] = this.orderInformation[0][key]
                .toString()
                .trim();
              if (
                parseInt(this.orderInformation[0][key]) !== 0 &&
                parseInt(this.orderInformation[0][key]) != 99
              ) {
                this.$message({
                  showClose: true,
                  message: "支付方式格式错误!",
                  type: "error",
                  duration: 10000
                });
                this.fileList = [];
                this.orderMsg = false;
                return;
              }
            } else {
              this.$message({
                showClose: true,
                message: "支付方式不能为空!",
                type: "error",
                duration: 10000
              });
              this.fileList = [];
              this.orderMsg = false;
              return;
            }
          }

          if (key === "name") {
            if (this.orderInformation[0][key] !== undefined) {
              this.orderInformation[0][key] = this.orderInformation[0][key]
                .toString()
                .trim();
              if (this.orderInformation[0][key].length > 50) {
                this.$message({
                  showClose: true,
                  message: "导游姓名不能超过50个字符!",
                  type: "error",
                  duration: 10000
                });
                this.fileList = [];
                this.orderMsg = false;
                return;
              }
            } else {
              this.$message({
                showClose: true,
                message: "导游姓名不能为空!",
                type: "error",
                duration: 10000
              });
              this.fileList = [];
              this.orderMsg = false;
              return;
            }
          }

          if (key === "phoneNumber") {
            if (this.orderInformation[0][key] !== undefined) {
              this.orderInformation[0][key] = this.orderInformation[0][key]
                .toString()
                .trim();
              //不能超过13位
              if (this.orderInformation[0][key].length > 13) {
                this.$message({
                  showClose: true,
                  message: "导游手机号不能超过13位!",
                  type: "error",
                  duration: 10000
                });
                this.fileList = [];
                this.orderMsg = false;
                return;
              }
              if (this.orderInformation[0][key] == "") {
                this.$message({
                  showClose: true,
                  message: "导游手机号不能为空!",
                  type: "error",
                  duration: 10000
                });
                this.fileList = [];
                this.orderMsg = false;
                return;
              }
            } else {
              this.$message({
                showClose: true,
                message: "导游手机号不能为空!",
                type: "error",
                duration: 10000
              });
              this.fileList = [];
              this.orderMsg = false;
              return;
            }
          }

          if (key === "IDNumber") {
            if (this.orderInformation[0][key] !== undefined) {
              this.orderInformation[0][key] = this.orderInformation[0][key]
                .toString()
                .trim();
              if (this.orderInformation[0][key].length > 18) {
                this.$message({
                  showClose: true,
                  message: "导游身份证号不能超过18位!",
                  type: "error",
                  duration: 10000
                });
                this.fileList = [];
                this.orderMsg = false;
                return;
              }
            } else {
              this.orderInformation[0][key] = "";
            }
          }

          if (key === "specialPopulation") {
            if (this.orderInformation[0][key] !== undefined) {
              this.orderInformation[0][key] = this.orderInformation[0][key]
                .toString()
                .trim();
            } else {
              this.orderInformation[0][key] = "";
            }
          }

          if (key === "teamArea") {
            if (this.orderInformation[0][key] !== undefined) {
              this.orderInformation[0][key] = this.orderInformation[0][key]
                .toString()
                .trim();
            } else {
              this.orderInformation[0][key] = "";
            }
          }

          if (key === "teamType") {
            if (this.orderInformation[0][key] !== undefined) {
              this.orderInformation[0][key] = this.orderInformation[0][key]
                .toString()
                .trim();
            } else {
              this.orderInformation[0][key] = "";
            }
          }

          if (key === "remarks") {
            if (this.orderInformation[0][key] !== undefined) {
              this.orderInformation[0][key] = this.orderInformation[0][key]
                .toString()
                .trim();
              if (this.orderInformation[0][key].length > 50) {
                this.$message({
                  showClose: true,
                  message: "备注内容不能超过50个字符!",
                  type: "error",
                  duration: 10000
                });
                this.fileList = [];
                this.orderMsg = false;
                return;
              }
            } else {
              this.orderInformation[0][key] = "";
            }
          }
        }
        if (
          this.orderInformation[0]["startTime"] >
          this.orderInformation[0]["endTime"]
        ) {
          this.$message({
            showClose: true,
            message: "游玩开始时间不能大于游玩结束时间!",
            type: "error",
            duration: 10000
          });
          this.orderMsg = false;
          this.fileList = [];
          return;
        }
      } else {
        this.$message({
          showClose: true,
          message: "订单信息不能为空!",
          type: "error",
          duration: 10000
        });
        this.fileList = [];
        this.orderMsg = false;
      }
      console.log("Processed Table 1:", this.orderInformation);
    },

    //! 处理文件第二个表
    processTable2(table2) {
      const processedTable2 = table2.map(row => {
        return {
          name: row["游客姓名"],
          certificateNumber: row["游客证件号"],
          certificateType: row["证件类型"],
          certificateTypeText: this.certificateTypeList[
            parseInt(row["证件类型"])
          ],
          phoneNumber: row["游客手机号"],
          supportingMaterials: row["佐证材料"],
          supportingMaterialsText: row["佐证材料"],
          sex: row["游客性别"],
          belongingArea: row["所属区域（省/市）"],
          height: row["身高(厘米)"],
          remarks: row["备注"],
          result: ""
        };
      });
      console.log(processedTable2);
      if (processedTable2.length > 0) {
        this.touristList = processedTable2;
        this.touristList.forEach((item, index) => {
          let result = [];
          if (!item.name) {
            result.push("游客姓名不能为空");
          } else {
            this.touristList[index].name = item.name.toString().trim();
            if (this.touristList[index].name.length > 50) {
              result.push("游客姓名不能超过50个字符");
            }
          }

          if (item.phoneNumber) {
            let reg = /^1[3456789]\d{9}$/;
            if (!reg.test(item.phoneNumber.toString().trim())) {
              result.push("手机号格式错误");
            } else {
              this.touristList[
                index
              ].phoneNumber = item.phoneNumber.toString().trim();
              if (this.touristList[index].phoneNumber.length > 20) {
                result.push("手机号不能超过20位");
              }
            }
          }
          if (item.supportingMaterialsText) {
            let setSupportingMaterials = () => {
              let text = item.supportingMaterials.toString().trim();
              if (text == "是") {
                return "1";
              } else if (text == "否") {
                return "0";
              } else {
                return "";
              }
            };
            if (setSupportingMaterials() != "") {
              this.touristList[
                index
              ].supportingMaterials = setSupportingMaterials();
              this.touristList[
                index
              ].supportingMaterialsText = item.supportingMaterialsText
                .toString()
                .trim();
            } else {
              result.push("佐证材料输入错误");
            }
          }

          // if (item.sex !== 0 && item.sex !== 1 && item.sex !== null) {
          //   result.push("性别格式错误");
          // } else {
          //   if (item.sex == 0) {
          //     this.touristList[index].sex = "男";
          //   } else if (item.sex == 1) {
          //     this.touristList[index].sex = "女";
          //   } else {
          //     this.touristList[index].sex = "未知";
          //   }
          // }

          if (
            parseInt(item.certificateType) !== 0 &&
            parseInt(item.certificateType) !== 1 &&
            parseInt(item.certificateType) !== 2 &&
            parseInt(item.certificateType) !== null
          ) {
            result.push("证件类型格式错误");
          } else {
            if (!item.certificateNumber) {
              result.push("证件号不能为空");
            } else {
              this.touristList[index].certificateNumber = item.certificateNumber.toString().trim();
              if (this.touristList[index].certificateNumber.length > 20) {
                result.push("证件号不能超过20个字符");
              }
              this.touristList[index].certificateType = parseInt(item.certificateType);
            }
          }
          console.log(parseInt(item.certificateType) == 0 && item.certificateNumber);

          if (parseInt(item.certificateType) == 0 && item.certificateNumber) {
            let id = item.certificateNumber.toString().trim();
            if (!/^\d{17}[\dXx]$/.test(id)) {
              result.push(
                "身份证号错误：格式不符合要求（需17位数字+1位数字/X）"
              );
            }
            if (id.length !== 18) result.push("身份证号错误：长度必须为18位");
            if (!/^[1-9]\d{5}/.test(id)) {
              result.push(
                "身份证号错误：地址码错误（前6位需为非零开头的行政区划代码）"
              );
            }
            const year = parseInt(id.substr(6, 4));
            const month = parseInt(id.substr(10, 2));
            const day = parseInt(id.substr(12, 2));
            // 月份范围检查
            if (month < 1 || month > 12) {
              result.push(`身份证号错误：月份${month}不合法`);
            }

            // 日期有效性检查
            const date = new Date(year, month - 1, day);
            if (
              date.getFullYear() !== year ||
              date.getMonth() + 1 !== month ||
              date.getDate() !== day
            ) {
              result.push(`身份证号错误：日期${year}-${month}-${day}不存在`);
            }
          }

          if (item.belongingArea) {
            this.touristList[index].belongingArea = item.belongingArea.toString().trim();
          }

          if (item.height) {
            let height = parseInt(item.height);
            if (height < 0 || height > 250 || isNaN(height)) {
              result.push("身高格式错误");
            }
          }

          if (item.remarks) {
            this.touristList[index].remarks = item.remarks.toString().trim();
            if (this.touristList[index].remarks.length > 50) {
              result.push("备注内容不能超过50个字符");
            }
          }

          this.touristList[index].result = result;
        });
        this.setTouristListData();
        this.dialogTableVisible = true;
      } else {
        this.$message({
          showClose: true,
          message: "游客信息不能为空!",
          type: "error",
          duration: 10000
        });
        this.fileList = [];
        this.orderMsg = false;
      }
    },

    //!判断表格行是否需要高亮显示(有错误信息则高亮显示)
    tableRowClassName({ row }) {
      if (row.result.length > 0) {
        return "highlight-row";
      }
      return "";
    },

    //!添加游客预览表数据
    setTouristListData() {
      this.touristList_paginate = this.touristList.slice(
        (this.page.pageNumber - 1) * this.page.pageItems,
        this.page.pageNumber * this.page.pageItems
      );
      this.tableDataLength = this.touristList.length;
    },

    //!游客预览表每页条数
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.page.pageItems = `${val}`;
      this.setTouristListData();
    },

    //!游客预览表分页
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.page.pageNumber = val;
      this.setTouristListData();
    },

    //!确认游客预览表数据
    confirm() {
      let allResultsEmpty = this.touristList.every(item => item.result == "");
      if (allResultsEmpty) {
        this.checkTouristList = false;
        this.dialogTableVisible = false;
      } else {
        this.$message({
          showClose: true,
          message: "存在游客信息验证不通过的情况，请检查！",
          type: "warning",
          duration: 10000
        });
      }
      this.page.pageNumber = 1;
    },

    //!取消游客预览表数据
    cancel() {
      this.orderDetailsList = {
        orderInformation: {},
        ticketList: []
      };
      this.page.pageNumber = 1;
      this.dialogTableVisible = false;
    },

    //!表格表头样式
    thStyleFun() {
      return "text-align:center";
    },

    //!表格单元格样式
    cellStyleFun() {
      return "text-align:center";
    },

    //!删除上传文件
    handleRemove(file, fileList) {
      this.fileTemp = null;
    },

    //!点击上传文件打开预览
    handlePreview(file) {
      this.page.pageNumber = 1;
      this.setTouristListData();
      this.dialogTableVisible = true;
    },

    //!回退某一步
    lastStep(index) {
      this.orderDetailsList = {
        orderInformation: {},
        ticketList: []
      };
      this.orderTicketListLaunch = false;
      this.activeStep = index;
    },

    //!取消创建订单
    cancelCreate() {
      this.$confirm("此操作将删除上传的文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.fileList = [];
          this.orderInformation = [];
          this.touristList = [];
          this.touristList_paginate = [];
          this.fileTemp = null;
          this.page.pageNumber = 1;
          this.page.pageItems = 10;
          this.orderDetailsList = {
            orderInformation: {},
            ticketList: []
          };
          this.checkTouristList = true;
        })
        .catch(() => { });
    },

    //!跳转下一步
    nextStep(index) {
      this.activeStep = index;
    },

    //!创建订单
    async createOrder(index) {
      let storage = window.sessionStorage;
      let travelAgencyID = JSON.parse(storage.getItem("travelAgency")).id;
      let hasError = false;
      this.orderDetailsList.orderInformation = this.orderInformation[0];
      //!将每张票交给后台进行匹配
      const promises = this.touristList.map(async (item, index) => {
        await this.$axios({
          url: "/api/ticketMatch/travelAgencyMatchTicketType",
          method: "post",
          data: {
            travelAgencyID: travelAgencyID,
            ticketTypeID: this.ticketType,
            idCardNum: item.certificateNumber,
            certificateType: item.certificateType,
            height: item.height
          }
        })
          .then(async res => {
            if (res.data.res_code == "fail") {
              hasError = true;
              this.touristList[index].result = [];
              this.touristList[index].result.push(res.data.res_msg);
            }
            if (!hasError) {
              let ticketName = res.data.data.matchTicketType.ticketTypeName;
              let ticketId = res.data.data.matchTicketType.id;
              let isConcession = res.data.data.matchTicketType.isConcession;
              let price = res.data.data.matchTicketType.ticketPrice;
              let name = item.name;
              let phoneNumber = item.phoneNumber;
              let supportingMaterials = item.supportingMaterials;
              let supportingMaterialsText = item.supportingMaterialsText;
              let certificateNumber = item.certificateNumber;
              let certificateType = item.certificateType;
              let certificateTypeText = item.certificateTypeText;
              let sex = item.sex;
              let age = res.data.data.IDInfo.age;
              let area = item.belongingArea;
              let height = item.height;
              let remarks = item.remarks;
              let matchingDetails = res.data.data.matchResult;
              this.orderDetailsList.ticketList.push({
                ticketId,
                ticketName,
                isConcession,
                price,
                name,
                phoneNumber,
                supportingMaterials,
                supportingMaterialsText,
                certificateNumber,
                certificateType,
                certificateTypeText,
                sex,
                age,
                area,
                height,
                remarks,
                matchingDetails
              });
            }
          })
          .catch(err => {
            console.log(err);
            this.$message({
              showClose: true,
              message: "出错啦~" + err,
              type: "error",
              duration: 10000
            });
          });
      });

      await Promise.all(promises);

      if (hasError) {
        this.page.pageNumber = 1;
        this.setTouristListData();
        this.dialogTableVisible = true;
      } else {
        this.activeStep = index;
        this.setOrderStatisticsData();
        this.setTicketListData(1);
      }
    },

    //!修改支付方式
    handleCommand(command) {
      if (command == "0") {
        this.orderDetailsList.orderInformation.payWay = 0;
      } else {
        this.orderDetailsList.orderInformation.payWay = 99;
      }
    },

    //!添加订单统计数据
    setOrderStatisticsData() {
      let orderAmount = 0;
      this.orderStatistics.orderPeopleNum = this.orderDetailsList.ticketList.length;
      this.orderStatistics.orderTicketList = [];
      this.orderDetailsList.ticketList.forEach(item => {
        orderAmount += item.price;
        const existingItemIndex = this.orderStatistics.orderTicketList.findIndex(
          ticket => ticket.ticketName === item.ticketName
        );
        if (existingItemIndex !== -1) {
          this.orderStatistics.orderTicketList[existingItemIndex].num += 1;
        } else {
          this.orderStatistics.orderTicketList.push({
            ticketName: item.ticketName,
            num: 1
          });
        }
      });
      this.orderStatistics.orderAmount = orderAmount;
      console.log(this.orderStatistics);
    },

    //!票表格查询
    selectVisitorFun() {
      this.page_ticketList.pageNumber = 1;
      this.setTicketListData(this.selectTabsIndex);
    },

    //!切换票表格tab标签
    handleClick(tab, event) {
      this.selectTabsIndex = parseInt(tab.name);
      this.page_ticketList.pageNumber = 1;
      this.setTicketListData(parseInt(tab.name));
    },

    //!添加订单的票表格数据，实现票表格分类、分页
    setTicketListData(tabsIndex) {
      if (tabsIndex == 1) {
        let concessionTickets = this.orderDetailsList.ticketList;
        concessionTickets = concessionTickets.filter(ticket => {
          const name = ticket.name || "";
          const phoneNumber = ticket.phoneNumber || "";
          const certificateNumber = ticket.certificateNumber || "";
          return (
            name.includes(this.selectVisitor) ||
            phoneNumber.includes(this.selectVisitor) ||
            certificateNumber.includes(this.selectVisitor)
          );
        });
        this.ticketListTable = concessionTickets.slice(
          (this.page_ticketList.pageNumber - 1) *
          this.page_ticketList.pageItems,
          this.page_ticketList.pageNumber * this.page_ticketList.pageItems
        );
        this.ticketListTableDataLength = concessionTickets.length;
      } else if (tabsIndex == 2) {
        let concessionTickets = this.orderDetailsList.ticketList.filter(
          ticket => ticket.isConcession === true
        );
        concessionTickets = concessionTickets.filter(
          ticket =>
            ticket.name.includes(this.selectVisitor) ||
            ticket.phoneNumber.includes(this.selectVisitor) ||
            ticket.certificateNumber.includes(this.selectVisitor)
        );
        this.ticketListTable = concessionTickets.slice(
          (this.page_ticketList.pageNumber - 1) *
          this.page_ticketList.pageItems,
          this.page_ticketList.pageNumber * this.page_ticketList.pageItems
        );
        this.ticketListTableDataLength = concessionTickets.length;
      } else if (tabsIndex == 3) {
        let concessionTickets = this.orderDetailsList.ticketList.filter(
          ticket => ticket.isConcession === false
        );
        concessionTickets = concessionTickets.filter(
          ticket =>
            ticket.name.includes(this.selectVisitor) ||
            ticket.phoneNumber.includes(this.selectVisitor) ||
            ticket.certificateNumber.includes(this.selectVisitor)
        );
        this.ticketListTable = concessionTickets.slice(
          (this.page_ticketList.pageNumber - 1) *
          this.page_ticketList.pageItems,
          this.page_ticketList.pageNumber * this.page_ticketList.pageItems
        );
        this.ticketListTableDataLength = concessionTickets.length;
      }
      console.log(this.ticketListTable);
    },

    //!编辑票(tab1)
    editTicket_tab1(row) {
      console.log(row);
      const index = this.orderDetailsList.ticketList.indexOf(row);
      this.editTouristsForm.index = index;
      this.editTouristsForm.tabsIndex = 1;
      this.editTouristsForm.certificateNumber = row.certificateNumber;
      this.editTouristsForm.certificateType = row.certificateType;
      this.editTouristsForm.ticketTypeId = row.ticketId;
      this.editTouristsForm.price = row.price;
      this.editTouristsForm.isConcession =
        row.isConcession == true ? "是" : "否";
      this.editTouristsForm.name = row.name;
      this.editTouristsForm.phoneNumber = row.phoneNumber;
      this.editTouristsForm.supportingMaterials = row.supportingMaterials;
      //   this.editTouristsForm.sex = row.sex == "男" ? "0" : "1";
      if (row.sex == "男") {
        this.editTouristsForm.sex = "0";
      } else if (row.sex == "女") {
        this.editTouristsForm.sex = "1";
      } else {
        this.editTouristsForm.sex = "";
      }
      this.editTouristsForm.age = row.age;
      this.editTouristsForm.area = row.area;
      this.editTouristsForm.height = row.height;
      this.editTouristsForm.remarks = row.remarks;
      this.editTouristsForm.matchingDetails = row.matchingDetails;
      this.editTicketTypeChange(row.ticketId);
      this.editTouristsDrawer = true;
    },

    //!编辑票(tab2)
    editTicket_tab2(row) {
      console.log(row);
      const index = this.orderDetailsList.ticketList.indexOf(row);
      this.editTouristsForm.index = index;
      this.editTouristsForm.tabsIndex = 2;
      this.editTouristsForm.certificateNumber = row.certificateNumber;
      this.editTouristsForm.certificateType = row.certificateType;
      this.editTouristsForm.ticketTypeId = row.ticketId;
      this.editTouristsForm.price = row.price;
      this.editTouristsForm.isConcession =
        row.isConcession == true ? "是" : "否";
      this.editTouristsForm.name = row.name;
      this.editTouristsForm.phoneNumber = row.phoneNumber;
      this.editTouristsForm.supportingMaterials = row.supportingMaterials;
      //   this.editTouristsForm.sex = row.sex == "男" ? "0" : "1";
      if (row.sex == "男") {
        this.editTouristsForm.sex = "0";
      } else if (row.sex == "女") {
        this.editTouristsForm.sex = "1";
      } else {
        this.editTouristsForm.sex = "";
      }
      this.editTouristsForm.age = row.age;
      this.editTouristsForm.area = row.area;
      this.editTouristsForm.height = row.height;
      this.editTouristsForm.remarks = row.remarks;
      this.editTouristsForm.matchingDetails = row.matchingDetails;
      this.editTicketTypeChange(row.ticketId);
      this.editTouristsDrawer = true;
    },

    //!编辑票(tab3)
    editTicket_tab3(row) {
      console.log(row);
      const index = this.orderDetailsList.ticketList.indexOf(row);
      this.editTouristsForm.index = index;
      this.editTouristsForm.tabsIndex = 3;
      this.editTouristsForm.certificateNumber = row.certificateNumber;
      this.editTouristsForm.certificateType = row.certificateType;
      this.editTouristsForm.ticketTypeId = row.ticketId;
      this.editTouristsForm.price = row.price;
      this.editTouristsForm.isConcession =
        row.isConcession == true ? "是" : "否";
      this.editTouristsForm.name = row.name;
      this.editTouristsForm.phoneNumber = row.phoneNumber;
      this.editTouristsForm.supportingMaterials = row.supportingMaterials;
      //   this.editTouristsForm.sex = row.sex == "男" ? "0" : "1";
      if (row.sex == "男") {
        this.editTouristsForm.sex = "0";
      } else if (row.sex == "女") {
        this.editTouristsForm.sex = "1";
      } else {
        this.editTouristsForm.sex = "";
      }
      this.editTouristsForm.age = row.age;
      this.editTouristsForm.area = row.area;
      this.editTouristsForm.height = row.height;
      this.editTouristsForm.remarks = row.remarks;
      this.editTouristsForm.matchingDetails = row.matchingDetails;
      this.editTicketTypeChange(row.ticketId);
      this.editTouristsDrawer = true;
    },

    //!编辑票类型
    editTicketTypeChange(val) {
      this.options_ticketType_all.find(item => {
        if (item.value == val) {
          this.editTouristsForm.price = item.price;
          this.editTouristsForm.ticketTypeName = item.label;
          this.editTouristsForm.isConcession =
            item.isConcession == true ? "是" : "否";
          this.editTouristsForm.matchingDetails = ["编辑自选票类"];
        }
      });
    },

    //!确认编辑票
    submitEditTourists(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.orderDetailsList.ticketList[
            this.editTouristsForm.index
          ].ticketId = this.editTouristsForm.ticketTypeId;
          this.orderDetailsList.ticketList[
            this.editTouristsForm.index
          ].ticketName = this.editTouristsForm.ticketTypeName;
          this.orderDetailsList.ticketList[
            this.editTouristsForm.index
          ].isConcession =
            this.editTouristsForm.isConcession == "是" ? true : false;
          this.orderDetailsList.ticketList[
            this.editTouristsForm.index
          ].price = this.editTouristsForm.price;
          this.orderDetailsList.ticketList[
            this.editTouristsForm.index
          ].name = this.editTouristsForm.name;
          this.orderDetailsList.ticketList[
            this.editTouristsForm.index
          ].phoneNumber = this.editTouristsForm.phoneNumber;
          this.orderDetailsList.ticketList[
            this.editTouristsForm.index
          ].supportingMaterials = this.editTouristsForm.supportingMaterials;
          this.orderDetailsList.ticketList[
            this.editTouristsForm.index
          ].supportingMaterialsText =
            this.editTouristsForm.supportingMaterials == "0" ? "否" : "是";
          this.orderDetailsList.ticketList[
            this.editTouristsForm.index
          ].certificateNumber = this.editTouristsForm.certificateNumber;
          this.orderDetailsList.ticketList[
            this.editTouristsForm.index
          ].certificateType = this.editTouristsForm.certificateType;
          this.orderDetailsList.ticketList[
            this.editTouristsForm.index
          ].certificateTypeText = this.certificateTypeList[
            this.editTouristsForm.certificateType
            ];
          if (this.editTouristsForm.sex == "0") {
            this.orderDetailsList.ticketList[this.editTouristsForm.index].sex =
              "男";
          } else if (this.editTouristsForm.sex == "1") {
            this.orderDetailsList.ticketList[this.editTouristsForm.index].sex =
              "女";
          } else {
            this.orderDetailsList.ticketList[this.editTouristsForm.index].sex =
              "未知";
          }
          this.orderDetailsList.ticketList[
            this.editTouristsForm.index
          ].age = this.editTouristsForm.age;
          this.orderDetailsList.ticketList[
            this.editTouristsForm.index
          ].area = this.editTouristsForm.area;
          this.orderDetailsList.ticketList[
            this.editTouristsForm.index
          ].height = this.editTouristsForm.height;
          this.orderDetailsList.ticketList[
            this.editTouristsForm.index
          ].remarks = this.editTouristsForm.remarks;
          this.orderDetailsList.ticketList[
            this.editTouristsForm.index
          ].matchingDetails = this.editTouristsForm.matchingDetails;

          console.log(this.editTouristsForm);
          this.setOrderStatisticsData();
          this.setTicketListData(this.editTouristsForm.tabsIndex);
          this.$refs[formName].resetFields();
          this.editTouristsDrawer = false;
          this.$message({
            message: "修改成功",
            type: "success",
            duration: 10000
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    //!取消编辑票
    cancelEditTouristsFormDrawer(formName) {
      this.$refs[formName].resetFields();
      this.editTouristsDrawer = false;
    },

    //!删除票(tab1)
    deleteTicket_tab1(row) {
      const index = this.orderDetailsList.ticketList.indexOf(row);
      this.orderDetailsList.ticketList.splice(index, 1);
      this.setOrderStatisticsData();
      this.setTicketListData(1);
    },

    //!删除票(tab2)
    deleteTicket_tab2(row) {
      const index = this.orderDetailsList.ticketList.indexOf(row);
      this.orderDetailsList.ticketList.splice(index, 1);
      this.setOrderStatisticsData();
      this.setTicketListData(2);
    },

    //!删除票(tab3)
    deleteTicket_tab3(row) {
      const index = this.orderDetailsList.ticketList.indexOf(row);
      this.orderDetailsList.ticketList.splice(index, 1);
      this.setOrderStatisticsData();
      this.setTicketListData(3);
    },

    //!分页(tab1)
    handleCurrentChange_ticketList_tab1(val) {
      this.page_ticketList.pageNumber = parseInt(val);
      this.setTicketListData(1);
    },

    //!分页(tab2)
    handleCurrentChange_ticketList_tab2(val) {
      this.page_ticketList.pageNumber = parseInt(val);
      this.setTicketListData(2);
    },

    //!分页(tab3)
    handleCurrentChange_ticketList_tab3(val) {
      this.page_ticketList.pageNumber = parseInt(val);
      this.setTicketListData(3);
    },

    //!保存订单
    saveOrder() {
      let data = {
        //旅行社ID
        travelAgencyID: this.travelAgencyID,
        //操作员ID
        accountID: this.userId,
        //订单金额
        orderAmount: this.orderStatistics.orderAmount,
        //游玩开始时间
        playStartTime: this.orderDetailsList.orderInformation.startTime,
        //游玩结束时间
        playEndTime: this.orderDetailsList.orderInformation.endTime,
        //支付方式
        payType: this.orderDetailsList.orderInformation.payWay,
        //导游姓名
        guideName: this.orderDetailsList.orderInformation.name,
        //导游手机号
        guideMobile: this.orderDetailsList.orderInformation.phoneNumber,
        //导游身份证号码
        guideIDCard: this.orderDetailsList.orderInformation.IDNumber,
        //订单状态 0-保存,1-提交审核
        orderStatus: 0,
        //订单备注
        baseInfo: {
          //特殊人群
          specialPeople: this.orderDetailsList.orderInformation
            .specialPopulation,
          //所属区域
          region: this.orderDetailsList.orderInformation.teamArea,
          //所属类型
          teamType: this.orderDetailsList.orderInformation.teamType,
          //备注
          remark: this.orderDetailsList.orderInformation.remarks
          // originalOrderPeopleCount: this.orderDetailsList.ticketList.length
        },
        //游客列表
        touristList: []
      };
      this.orderDetailsList.ticketList.forEach(item => {
        let sex = "";
        if (item.sex == "男") {
          sex = 0;
        } else if (item.sex == "女") {
          sex = 1;
        } else {
          sex = 2;
        }
        data.touristList.push({
          //票类型类型ID
          ticketTypeID: item.ticketId,
          ticketTypeName: item.ticketName,
          isConcession: item.isConcession,
          ticketPrice: item.price,
          //游客姓名
          name: item.name,
          //游客性别
          sex: sex,
          age: item.age,
          //游客手机号
          mobile: item.phoneNumber,
          supportingMaterials: item.supportingMaterials,
          supportingMaterialsText: item.supportingMaterialsText,
          //游客身份证号码
          IDCard: item.certificateNumber,
          certificateType: item.certificateType,
          //所属区域
          region: item.area,
          //身高
          height: item.height,
          //备注
          remark: item.remarks,
          matchingDetails: JSON.stringify(item.matchingDetails)
        });
      });

      console.log(data);
      this.$axios({
        url: "/api/travelAgency/importCreateOrder",
        method: "post",
        data
      })
        .then(res => {
          console.log(res);
          if (res.data.res_code == "success") {
            this.$message({
              showClose: true,
              message: "保存订单成功成功！",
              type: "success",
              duration: 10000
            });
            this.$router.push({
              path: "/travelAgencyOrderManagement_travelAgency"
            });
          } else {
            this.$message({
              showClose: true,
              message: "保存订单失败！" + res.data.res_msg,
              type: "error",
              duration: 10000
            });
          }
        })
        .catch(err => {
          console.log(err);
          this.$message({
            showClose: true,
            message: "保存订单失败！" + err,
            type: "error",
            duration: 10000
          });
        });
    },

    //!添加游客(tab1)
    addTourists_tab1() {
      this.addTouristsDrawer = true;
      this.addTouristsForm.tabsIndex = 1;
    },

    //!添加游客(tab2)
    addTourists_tab2() {
      this.addTouristsDrawer = true;
      this.addTouristsForm.tabsIndex = 2;
    },

    //!添加游客(tab3)
    addTourists_tab3() {
      this.addTouristsDrawer = true;
      this.addTouristsForm.tabsIndex = 3;
    },

    //!确认添加游客
    submitAddTourists(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.$axios({
            url: "/api/ticketMatch/travelAgencyMatchTicketType",
            method: "post",
            data: {
              travelAgencyID: this.travelAgencyID,
              ticketTypeID: this.ticketType,
              idCardNum: this.addTouristsForm.certificateNumber,
              certificateType: this.addTouristsForm.certificateType,
              height: this.addTouristsForm.height
            }
          })
            .then(res => {
              console.log(res);
              if (res.data.res_code == "success") {
                let ticketName = res.data.data.matchTicketType.ticketTypeName;
                let ticketId = parseInt(res.data.data.matchTicketType.id);
                let isConcession = res.data.data.matchTicketType.isConcession;
                let price = res.data.data.matchTicketType.ticketPrice;
                let name = this.addTouristsForm.name;
                let phoneNumber = this.addTouristsForm.phoneNumber;
                let supportingMaterials = this.addTouristsForm
                  .supportingMaterials;
                let supportingMaterialsText =
                  this.addTouristsForm.supportingMaterials == "0" ? "否" : "是";
                let certificateNumber = this.addTouristsForm.certificateNumber;
                let certificateType = this.addTouristsForm.certificateType;
                let certificateTypeText = this.certificateTypeList[
                  parseInt(this.addTouristsForm.certificateType)
                ];
                let sex = "";
                if (this.addTouristsForm.sex == 0) {
                  sex = "男";
                } else if (this.addTouristsForm.sex == 1) {
                  sex = "女";
                } else {
                  sex = "未知";
                }
                let age = res.data.data.IDInfo.age;
                let area = this.addTouristsForm.belongingArea;
                let height = this.addTouristsForm.height;
                let remarks = this.addTouristsForm.remarks;
                let matchingDetails = res.data.data.matchResult;
                this.orderDetailsList.ticketList.push({
                  ticketId,
                  ticketName,
                  isConcession,
                  price,
                  name,
                  phoneNumber,
                  supportingMaterials,
                  supportingMaterialsText,
                  certificateNumber,
                  certificateType,
                  certificateTypeText,
                  sex,
                  age,
                  area,
                  height,
                  remarks,
                  matchingDetails
                });

                this.setOrderStatisticsData();
                this.setTicketListData(this.addTouristsForm.tabsIndex);
                this.$message({
                  showClose: true,
                  message: "新增成功",
                  type: "success",
                  duration: 10000
                });
                this.addTouristsForm = {
                  certificateType: 0,
                  certificateTypeList: [
                    {
                      value: 0,
                      label: "身份证"
                    },
                    {
                      value: 1,
                      label: "港澳通行证"
                    },
                    {
                      value: 2,
                      label: "护照"
                    }
                  ]
                };
                this.$refs[formName].resetFields();
                this.addTouristsDrawer = false;
              } else {
                this.$message({
                  showClose: true,
                  message: "新增失败" + res.data.res_msg,
                  type: "error",
                  duration: 10000
                });
              }
            })
            .catch(error => {
              this.$message({
                showClose: true,
                message: "新增失败" + error,
                type: "error",
                duration: 10000
              });
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    //!取消添加
    cancelAddTouristsFormDrawer(formName) {
      this.$refs[formName].resetFields();
      this.addTouristsDrawer = false;
    },

    //!提交订单审核
    confirmOrder() {
      this.$confirm("请仔细核对订单内容,如无误请点击确认提交", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          let data = {
            //旅行社ID
            travelAgencyID: this.travelAgencyID,
            //操作员ID
            accountID: this.userId,
            //订单金额
            orderAmount: this.orderStatistics.orderAmount,
            //游玩开始时间
            playStartTime: this.orderDetailsList.orderInformation.startTime,
            //游玩结束时间
            playEndTime: this.orderDetailsList.orderInformation.endTime,
            //支付方式
            payType: this.orderDetailsList.orderInformation.payWay,
            //导游姓名
            guideName: this.orderDetailsList.orderInformation.name,
            //导游手机号
            guideMobile: this.orderDetailsList.orderInformation.phoneNumber,
            //导游身份证号码
            guideIDCard: this.orderDetailsList.orderInformation.IDNumber,
            //订单状态 0-保存,1-提交审核,2-审核完成
            orderStatus: 1,
            //订单备注
            baseInfo: {
              //特殊人群
              specialPeople: this.orderDetailsList.orderInformation
                .specialPopulation,
              //所属区域
              region: this.orderDetailsList.orderInformation.teamArea,
              //所属类型
              teamType: this.orderDetailsList.orderInformation.teamType,
              //备注
              remark: this.orderDetailsList.orderInformation.remarks,
              originalOrderPeopleCount: this.orderDetailsList.ticketList.length
            },
            //游客列表
            touristList: []
          };
          this.orderDetailsList.ticketList.forEach(item => {
            let sex = "";
            if (item.sex == "男") {
              sex = 0;
            } else if (item.sex == "女") {
              sex = 1;
            } else {
              sex = 2;
            }
            data.touristList.push({
              //票类型类型ID
              ticketTypeID: item.ticketId,
              ticketTypeName: item.ticketName,
              isConcession: item.isConcession,
              ticketPrice: item.price,
              //游客姓名
              name: item.name,
              //游客性别
              sex: sex,
              age: item.age,
              //游客手机号
              mobile: item.phoneNumber,
              supportingMaterials: item.supportingMaterials,
              supportingMaterialsText: item.supportingMaterialsText,
              //游客身份证号码
              IDCard: item.certificateNumber,
              certificateType: item.certificateType,
              //所属区域
              region: item.area,
              //身高
              height: item.height,
              //备注
              remark: item.remarks,
              matchingDetails: JSON.stringify(item.matchingDetails)
            });
          });

          console.log(data);
          this.$axios({
            url: "/api/travelAgency/importCreateOrder",
            method: "post",
            data
          })
            .then(res => {
              console.log(res);
              if (res.data.res_code == "success") {
                this.$message({
                  showClose: true,
                  message: "提交审核成功！",
                  type: "success",
                  duration: 10000
                });
                this.$router.push({
                  path: "/travelAgencyOrderManagement_travelAgency?status=1"
                });
              } else {
                this.$message({
                  showClose: true,
                  message: "提交审核失败！" + res.data.res_msg,
                  type: "error",
                  duration: 10000
                });
              }
            })
            .catch(err => {
              console.log(err);
              this.$message({
                showClose: true,
                message: "提交审核失败！" + err,
                type: "error",
                duration: 10000
              });
            });
        })
        .catch(() => { });
    }
  }
};
</script>
<style lang="scss" scoped>
.body {
  padding-left: 50px;
  padding-right: 50px;

  .title {
    margin-top: 5px;
    margin-left: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    span {
      font-size: 18px;
      color: rgb(160, 160, 160);
    }

    .el-button {
      font-size: 17px;
    }
  }

  .tips {
    height: 45px;
    background-color: rgba(255, 141, 26, 0.2);
    margin-top: 10px;
    border-radius: 10px;
    padding-left: 15px;
    display: flex;
    align-items: center;

    span {
      font-size: 16px;
      color: rgba(212, 48, 48, 1);
    }

    .quota {
      font-size: 18px;
      color: black;
      font-weight: bold;
    }

    .orderAmount {
      font-size: 18px;
      color: black;
      font-weight: bold;
    }
  }

  .step {
    margin-top: 10px;
    height: 100px;
    background-color: rgba(42, 130, 228, 1);
    display: flex;
    flex-direction: column;
    justify-content: center;

    .stepItem {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      .text1 {
        font-size: 23px;
        font-weight: bold;
      }

      .text2 {
        margin-top: 20px;
        font-size: 23px;
      }
    }
  }

  .step1 {
    .selectTicketType {
      display: flex;
      flex-direction: column;
      border: 2px solid rgba(206, 206, 206, 0.26);
      margin-top: 10px;
      padding: 20px;

      .ticketType {
        display: flex;
        flex-direction: column;

        span {
          font-size: 17px;
          margin-bottom: 5px;
        }
      }

      .text {
        display: flex;
        flex-direction: column;
        font-size: 17px;
        margin-top: 10px;
      }

      .download {
        .el-button {
          font-size: 23px;
        }
      }
    }

    .next {
      display: flex;
      justify-content: end;
      margin-top: 15px;

      .el-button {
        width: 100%;
        font-size: 18px;
      }
    }
  }

  .step2 {
    .upload {
      margin-top: 15px;
      display: flex;
      flex-direction: column;
      border: 2px solid rgba(206, 206, 206, 0.26);
      margin-top: 10px;
      padding: 20px;

      .uploadItem {
        display: flex;
        flex-direction: column;

        span {
          font-size: 17px;
          margin-bottom: 5px;
        }

        .uploadTouristInformation {
          width: 100%;

          .el-button {
            width: 100%;
            font-size: 18px;
          }
        }

        .uploadSuccess {
          height: 45px;
          background-color: rgba(42, 130, 228, 1);
          display: flex;
          justify-content: center;
          align-items: center;
          border-radius: 10px;

          span {
            color: white;
            font-size: 18px;
          }
        }
      }

      .text {
        display: flex;
        flex-direction: column;
        font-size: 17px;
        margin-top: 10px;
      }

      .download {
        .el-button {
          font-size: 23px;
        }
      }
    }

    .nextOrBack {
      display: flex;
      justify-content: space-evenly;
      margin-top: 15px;

      .el-button {
        width: 48%;
        font-size: 18px;
      }
    }
  }

  .preview {
    .ellipsis {
      display: inline-block;
      max-width: 100%;
      /* 根据需要调整最大宽度 */
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      cursor: pointer;
    }
  }

  .step3 {
    border: 1px solid rgba(206, 206, 206, 0.26);
    margin-top: 10px;

    .orderInformation {
      padding: 20px;

      .el-row {
        margin-bottom: 10px;

        &:last-child {
          margin-bottom: 0px;
        }

        .el-col {
          span {
            font-size: 15px;
            color: rgb(65, 65, 65);
          }

          .ellipsis {
            display: inline-block;
            max-width: 100%;
            /* 根据需要调整最大宽度 */
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            cursor: pointer;
          }

          .el-dropdown-link {
            cursor: pointer;
            color: #409eff;
          }

          .el-icon-arrow-down {
            font-size: 12px;
          }
        }
      }
    }

    .orderStatistics {
      border: 1px solid rgba(139, 139, 139, 0.384);
      margin-top: 10px;
      margin-left: 20px;
      margin-right: 20px;
      display: flex;

      .orderNumber {
        width: 13%;
        display: flex;
        flex-direction: column;
        justify-content: space-evenly;
        align-items: center;
        border-right: 1px solid rgba(153, 153, 153, 0.534);

        .orderNumberTitle {
          width: 100%;
          padding-top: 5px;
          padding-bottom: 5px;
          text-align: center;
          font-size: 17px;
          color: rgb(48, 48, 48);
          background-color: rgba(33, 166, 255, 0.1);
        }

        .line {
          width: 100%;
          border-top: 1px dashed rgba(153, 153, 153, 0.534);
        }

        .orderNumberText {
          margin-top: 5px;
          margin-bottom: 5px;
          font-size: 16px;
          color: rgb(65, 65, 65);
        }
      }

      .orderAmount {
        width: 8%;
        display: flex;
        flex-direction: column;
        justify-content: space-evenly;
        align-items: center;
        border-right: 1px solid rgba(153, 153, 153, 0.534);

        .orderAmountTitle {
          width: 100%;
          padding-top: 5px;
          padding-bottom: 5px;
          text-align: center;
          font-size: 17px;
          color: rgb(48, 48, 48);
          background-color: rgba(33, 166, 255, 0.1);
        }

        .line {
          width: 100%;
          border-top: 1px dashed rgba(153, 153, 153, 0.534);
        }

        .orderAmountText {
          margin-top: 5px;
          margin-bottom: 5px;
          font-size: 16px;
          color: rgb(65, 65, 65);
        }
      }

      .orderPeopleNum {
        width: 7%;
        display: flex;
        flex-direction: column;
        justify-content: space-evenly;
        align-items: center;
        border-right: 1px solid rgba(153, 153, 153, 0.534);

        .orderPeopleNumTitle {
          width: 100%;
          padding-top: 5px;
          padding-bottom: 5px;
          text-align: center;
          font-size: 17px;
          color: rgb(48, 48, 48);
          background-color: rgba(33, 166, 255, 0.1);
        }

        .line {
          width: 100%;
          border-top: 1px dashed rgba(153, 153, 153, 0.534);
        }

        .orderPeopleNumText {
          margin-top: 5px;
          margin-bottom: 5px;
          font-size: 16px;
          color: rgb(65, 65, 65);
        }
      }

      .orderTicketPeopleList {
        display: flex;
        flex-direction: column;
        justify-content: space-evenly;
        align-items: center;
        border-right: 1px solid rgba(153, 153, 153, 0.534);

        &:last-child {
          border-right: none;
        }

        .orderTicketPeopleListTitle {
          width: 100%;
          padding-top: 5px;
          padding-bottom: 5px;
          text-align: center;
          font-size: 17px;
          color: rgb(48, 48, 48);
          background-color: rgba(33, 166, 255, 0.1);
        }

        .line {
          width: 100%;
          border-top: 1px dashed rgba(153, 153, 153, 0.534);
        }

        .orderTicketPeopleListText {
          margin-top: 5px;
          margin-bottom: 5px;
          font-size: 16px;
          color: rgb(65, 65, 65);
        }
      }
    }

    .orderTicketList {
      border: 2px solid rgba(139, 139, 139, 0.384);
      margin-top: 10px;
      margin-left: 20px;
      margin-right: 20px;
      border-bottom: none;
      display: flex;
      justify-content: center;

      .selectVisitor {
        margin-top: 15px;
        margin-bottom: 5px;
        position: relative;
        width: 100%;

        .btn-area {
          width: 310px;
          position: absolute;
          top: 0;
          right: 10px;
          display: flex;
          justify-content: space-between;
        }

        .tables {
          width: 100%;

          .pub-container {
            min-width: 1280px;
            display: flex;
            flex-wrap: wrap;
          }

          .ticketList {
            .ellipsis {
              display: inline-block;
              max-width: 100%;
              /* 根据需要调整最大宽度 */
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              cursor: pointer;
            }

            .favourable {
              width: 25px;
              height: 25px;
              background-color: rgba(255, 141, 26, 1);
              color: white;
              border-radius: 100%;
              font-size: 17px;
              margin-left: 3px;
            }

            .ordinary {
              width: 25px;
              height: 25px;
              background-color: rgb(33, 166, 255);
              color: white;
              border-radius: 100%;
              font-size: 17px;
              margin-left: 3px;
            }
          }
        }
      }
    }
  }

  .addFormDrawer {
    .custom-title {
      display: flex;

      i {
        font-size: 30px;
        color: #3385ff;
      }

      span {
        margin-left: 5px;
        font-size: 20px;
        color: black;
      }
    }

    .addTouristsForm {
      height: 90%;
      padding-left: 20px;
      padding-right: 100px;
    }

    .addDrawerFooter {
      display: flex;
      justify-content: center;

      .submitAdd {
        width: 160px;
        font-size: 17px;
      }

      .cancelAdd {
        width: 160px;
        font-size: 17px;
        margin-left: 20px;
      }
    }
  }

  .editFormDrawer {
    .custom-title {
      display: flex;

      i {
        font-size: 30px;
        color: #3385ff;
      }

      span {
        margin-left: 5px;
        font-size: 20px;
        color: black;
      }
    }

    .editTouristsForm {
      height: 100%;
      padding-left: 20px;
      padding-right: 100px;

      .el-input-number .el-input__inner {
        text-align: left;
      }
    }

    .editDrawerFooter {
      display: flex;
      justify-content: center;
      margin-bottom: 15px;

      .submitEdit {
        width: 160px;
        font-size: 17px;
      }

      .cancelEdit {
        width: 160px;
        font-size: 17px;
        margin-left: 20px;
      }
    }
  }
}

/deep/ .step {
  .el-steps--simple {
    background-color: rgba(42, 130, 228, 1);
  }

  .el-step__head {
    display: none;
  }

  .el-step__title.is-success {
    color: rgba(255, 255, 255, 1);
  }

  .el-step__title.is-process {
    font-weight: 500;
    color: rgba(255, 255, 255, 0.65);
  }

  .el-step__title.is-wait {
    color: rgba(255, 255, 255, 0.65);
  }

  .el-step.is-simple .el-step__arrow::after,
  .el-step.is-simple .el-step__arrow::before {
    width: 3px;
    background-color: rgba(255, 255, 255, 0.8);
  }
}

/deep/ .step2 {
  .el-upload--text {
    width: 100%;
  }
}

/deep/ .highlight-row {
  background-color: rgb(228, 228, 228) !important;
  color: red;
}

/deep/ .tables {
  .el-tabs__item {
    font-size: 16px;
    font-weight: bold;
    color: rgb(167, 167, 167);
  }

  .el-tabs__item.is-active {
    color: #409eff;
  }

  .el-tabs__active-bar {
    height: 4px;
  }

  .el-tabs__nav-wrap::after {
    height: 4px;
  }

  .cell {
    display: flex;
    justify-content: center;
    align-items: center;
  }
}

/deep/ .editTouristsForm {
  .el-input-number .el-input__inner {
    text-align: left;
  }
}
</style>



// WEBPACK FOOTER //
// src/system/index/travelAgencyMenu/importOrder.vue